<template>
  <li
    aria-haspopup="true"
    data-menu-toggle="hover"
    class="menu-item"
    :class="{
      'menu-item-submenu': menu.submenu,
      'menu-item-open': activeMenu(menu)
    }"
  >
    <KTMenuItemText v-bind:menu="menu" @click="$emit('click')"></KTMenuItemText>
    <KTMenuSubmenu v-if="menu.submenu" v-bind:submenu="menu.submenu" v-bind:parentMenu="menu"></KTMenuSubmenu>
  </li>
</template>

<script>
import KTMenuItemText from "@/view/layout/aside/MenuItemText.vue";
import KTMenuSubmenu from "@/view/layout/aside/MenuSubmenu.vue";

export default {
  name: "KTMenuItem",
  components: {
    KTMenuItemText,
    KTMenuSubmenu
  },
  props: {
    menu: Object
  },
  methods: {
    activeMenu(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some(conf => {
        if (conf.submenu) {
          return this.activeMenu(conf.submenu);
        }
        if (conf.page) {
          // current path starts with this path string
          return this.$route.path === `/${conf.page}`;
        }
      });
    },
    /**
     * Get submenu toggle type
     * @param menu
     * @returns {string|*}
     */
    submenuToggle(menu) {
      if (menu.hasOwnProperty("toggle")) {
        return menu.toggle;
      }
      return "hover";
    }
  }
};
</script>
